import React from "react";
import { connect } from "react-redux";
import { denormalize } from "normalizr";
import PropTypes from "prop-types";
import PreLoader from "@wevo/react-components/lib/PreLoader";
import { pageResultsSchema, pageSchema } from "../../schemas";
import { shouldLoadOnMount } from "../../modules/asyncHttpAction";
import * as styles from "../../styles/components/KeyFindings.css";
import { BulletedList, BulletedListItem } from "../BulletedList";

class KeyFindings extends React.PureComponent {
    static propTypes = {
        pageId: PropTypes.number.isRequired
    };

    componentWillMount() {
        if (
            !this.props.findings ||
            shouldLoadOnMount(this.props.pageResultRequest)
        ) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.findings && prevProps.pageId !== this.props.pageId) {
            this.props.fetchPageResults(this.props.pageId);
        }
    }

    renderTitle() {
        return (
            <div className={styles.keyFindingsHeader}>
                <h2 className={styles.chapterTitle}>Key Findings</h2>
            </div>
        );
    }

    render() {
        if (!this.props.findings) {
            return (
                <div className={styles.chapter}>
                    {this.renderTitle()}
                    <div className={styles.preloader}>
                        <PreLoader />
                    </div>
                </div>
            );
        }

        if (this.props.findings.length === 0) {
            return (
                <div className={styles.chapter}>
                    {this.renderTitle()}
                    <p className={styles.findingsNoDataMessage}>
                        No key findings available yet.
                    </p>
                </div>
            );
        }

        return (
            <div className={styles.chapter}>
                {this.renderTitle()}
                <div className={styles.keyFindingsContentRow}>
                    <div className={styles.findingsContainer}>
                        <BulletedList>
                            {this.props.findings.map(finding => (
                                <BulletedListItem
                                    key={finding.id}
                                    headline={finding.headline}
                                    bullets={finding.bullets}
                                />
                            ))}
                        </BulletedList>
                    </div>
                    <div className={styles.imageContainer}>
                        <img
                            className={styles.image}
                            alt="A thumbnail of your page"
                            src={this.props.pageImageUrl}
                            onLoad={this.handleImageLoad}
                            ref={this.storeImageElementRef}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const { pageId } = props;
    const { pageResultRequest } = state.results;

    const page = denormalize(pageId, pageSchema, state.api) || null;
    const pageResults =
        denormalize(pageId, pageResultsSchema, state.api) || null;

    return {
        pageResultRequest,
        pageImageUrl: page && page.image.files.original.imageUrl,
        findings: pageResults && pageResults.keyFindings
    };
}

export default connect(mapStateToProps)(KeyFindings);



// WEBPACK FOOTER //
// ./src/components/Results/KeyFindings.js